import { render, staticRenderFns } from "./TimeBox.vue?vue&type=template&id=22618642&scoped=true"
import script from "./TimeBox.vue?vue&type=script&lang=js"
export * from "./TimeBox.vue?vue&type=script&lang=js"
import style0 from "./TimeBox.vue?vue&type=style&index=0&id=22618642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22618642",
  null
  
)

export default component.exports